import { ClientShipCodeMappingsModule } from '@/shared';

export default ClientShipCodeMappingsModule;
